import { BodyText } from "@/components/ui";

export const EncounterReopenMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        Encounter reopened - DFR or Previously Incomplete.
      </BodyText>
    </div>
  );
};
